import { neverHere } from "../tsHelpers";

export const toFriendlyName = (type: UserType) => {
  switch (type) {
    case UserType.Administrator:
      return "Administrator";
    case UserType.LtoEmployee:
      return "LTO Employee";
    case UserType.Customer:
      return "Customer";
    default:
      neverHere(type);
  }
};
